<main class="under-development-page" aria-labelledby="under-development-title">
  <section class="under-development-content">
    <app-under-development-status></app-under-development-status>

    <h1 id="under-development-title">Under Development</h1>

    <p class="under-development-lead">
      This page is being prepared and is not available for daily use yet.
      Please check back soon while the remaining work is completed.
    </p>

    <app-under-development-actions
      (homeRequested)="backToHome()"
      (refreshRequested)="refreshPage()">
    </app-under-development-actions>

    <app-under-development-checks></app-under-development-checks>
  </section>

  <app-under-development-illustration></app-under-development-illustration>
</main>
